import PropTypes from 'prop-types';
import './currency';

export const DiscountPropType = PropTypes.shape({
  amount: PropTypes.shape({
    value: PropTypes.number,
    code: PropTypes.string,
  }),
  description: PropTypes.string,
});

/**
 * @typedef {object} DiscountPropType
 * @property {CurrencyPropType} amount
 * @property {string} description
 */
